import { ENDPOINT_WORKSPACE_SETTINGS } from '../config'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const uploadWorkspaceLogo = async (
  workspaceSlug: string,
  file: File,
): Promise<{ url: string }> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await AuthAxios.post<{ url: string }>(
    `${ENDPOINT_WORKSPACE_SETTINGS}/${workspaceSlug}/settings/logo`,
    formData,
    {
      headers: {
        'Content-Type': undefined,
      },
    },
  )

  return response.data
}

export default uploadWorkspaceLogo
